export const TooltipTestIdFactory = {
    getTooltipBase: () => 'tooltip',
    getTooltipTestId: (testId) => [TooltipTestIdFactory.getTooltipBase(), testId].join('-'),
};
